import { createStyles, makeStyles } from '@material-ui/core/styles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      '& a': {
        marginBottom: SMALL_MARGIN,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
  }),
);

export default useStyles;
